import { type MapCountry } from '../../types'

export type CountryLabelPresentation = {
  text: string
  minZoom: number
  size: 'small' | 'large'
  light?: boolean
}

type CountryLabelStyle = Omit<CountryLabelPresentation, 'text'>

// Zoom 1 is the whole world with no country names; names appear only after zooming in.
const defaultLabel: CountryLabelStyle = {
  minZoom: 4.4,
  size: 'small',
}

const pointCountryLabel: CountryLabelStyle = {
  minZoom: 5.6,
  size: 'small',
}

const countryLabelOverrides: Record<string, CountryLabelStyle> = {
  RUS: { minZoom: 1.5, size: 'large' },
  KAZ: { minZoom: 1.5, size: 'large' },
  MNG: { minZoom: 1.5, size: 'large' },
  CHN: { minZoom: 1.5, size: 'large' },
  UKR: { minZoom: 3, size: 'small' },
  UZB: { minZoom: 3, size: 'small' },
  TUR: { minZoom: 3, size: 'small' },
  PAK: { minZoom: 3, size: 'small' },
  BLR: { minZoom: 3.7, size: 'small' },
}

const supplementaryLabels: Record<string, CountryLabelPresentation> = {
  BLR: { text: 'BELARUS', minZoom: 3.7, size: 'small' },
  EST: { text: 'ESTONIA', minZoom: 5.6, size: 'small' },
  LTU: { text: 'LITHUANIA', minZoom: 5.6, size: 'small' },
}

export const pointCountryIds = new Set([
  'ARM',
  'AZE',
  'CYP',
  'EST',
  'GEO',
  'HKG',
  'LVA',
  'LTU',
  'SGP',
  'TWN',
])

export const getIndicativeCaseCount = (country: MapCountry): string =>
  country.caseCount || (country.cases.length ? `${country.cases.length}+` : '—')

export const getCountryMapLabel = (
  countryId: string,
  country?: MapCountry
): CountryLabelPresentation | null => {
  if (!country) return supplementaryLabels[countryId] || null

  const presentation =
    countryLabelOverrides[countryId] ||
    (pointCountryIds.has(countryId) ? pointCountryLabel : defaultLabel)

  return {
    ...presentation,
    text: country.name.toLocaleUpperCase('en-GB'),
  }
}
